/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, ButtonGroup, Button, Grid, Typography, TextField } from '@mui/material'
import { Close, Check } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { connect } from 'react-redux'
import * as organization from '../../../appRedux/actions/fuel_request/organization'
import * as field from '../../../appRedux/actions/field'
import IntlMessages from '../../../util/IntlMessages'
import useStyles from './refueling.style'

function Refueling(props) {
    const anchor = 'bottom'
    const classes = useStyles()
    const onChangeHandler = (data, field) => props.setFields([{ data, field }])

    const volumeReceivedFunc = async () => {
        await props.fuelRequestOrganizationVolumeReceivedAction(props.vRequestCode)
        props.setRefuelingFunc()
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.refueling}
                onClose={() => props.setRefuelingFunc()}
            >
                <Grid className={classes.root}>
                    <Grid className={classes.gridTitle}>
                        <Typography variant="h5">
                            <IntlMessages id="dearOperator" />
                        </Typography>
                        <br />
                        <Typography variant="h5">
                            <IntlMessages id="toCompleteRefuelingProcessPleaseEnterExactAmountOfFuelDeliveredToUser" />
                        </Typography>
                    </Grid>
                    <Grid className={classes.gridTextField}>
                        <TextField
                            fullWidth
                            value={props.litrage}
                            onChange={(e) => onChangeHandler(e.target.value, 'litrage')}
                            autoFocus
                            type="number"
                            label={<IntlMessages id="litrage" />}
                            variant="outlined" />
                    </Grid>
                    <br />
                    <ButtonGroup variant="text" color="primary" fullWidth>
                        <Button
                            onClick={() => props.setRefuelingFunc()}
                            startIcon={<Close />}>
                            <IntlMessages id="cancel" />
                        </Button>
                        <LoadingButton
                            onClick={() => volumeReceivedFunc()}
                            loading={props.loadingBtn}
                            color="secondary"
                            startIcon={<Check />}>
                            <IntlMessages id="recordLiterature" />
                        </LoadingButton>
                    </ButtonGroup>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list,
        litrage: state.field.litrage,
        loadingBtn: state.common.loadingBtn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setFields: (data) => dispatch(field.setFields(data)),
        fuelRequestOrganizationVolumeReceivedAction: (code) =>
            dispatch(organization.fuelRequestOrganizationVolumeReceivedAction(code))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Refueling)